import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpHandler, HttpRequest, HttpEvent, HttpResponse } from '@angular/common/http';

import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/do';
import * as shajs from 'sha.js';

@Injectable()
export class MyInterceptor implements HttpInterceptor {
	intercept(
		req: HttpRequest<any>,
		next: HttpHandler
	): Observable<HttpEvent<any>> {
		//only run on login page
		if (!req.body || !req.body.password){
			return next.handle(req);
		}

		const email = req.body.email;
		const pass = req.body.password;
		const passhash = shajs('sha256').update(pass).digest('hex');
		const new_body = {
			email: email,
			password: passhash
		}
		const duplicate = req.clone({ body: new_body });
		return next.handle(duplicate);
	}
}
